import { Grid, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useGetMarketplaceJobsQuery } from "../../../Redux/api/jobApi"
import { useGetTalentsQuery } from "../../../Redux/api/talentApi"
import { useAppDispatch, useAppSelector } from "../../../Redux/store"
import { KaziJobCard } from "../../../Shared Components/Kazi/Cards/KaziJobCard"
import { KaziTalentCard } from "../../../Shared Components/Kazi/Cards/KaziTalentCard"
import { useTalentFilters } from "../../../Hooks/useTalentFilters"
import { useEffect } from "react"
import { getHasRequiredFields } from "../../../Utils/TalentUtils"
import { setPrevLocation, setShowBackButton } from "../../../Redux/slices/GlobalSlice"

export const SeeAll = () => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { getSpecialization } = useTalentFilters();
    const path = window.location.pathname;
    const title = path.substring(path.lastIndexOf('/')+1).replaceAll('%20',' ');
    const globalSlice = useAppSelector( state => state.Global);    
    const isClient = globalSlice.userType === 'client';
    const { data: jobs, isLoading: jobsLoading, isFetching: jobsFetching } = useGetMarketplaceJobsQuery(undefined, {
        skip: isClient
    });
    const {data: talents, isLoading: talentsLoading, isFetching: talentsFetching} = useGetTalentsQuery(undefined, {
        skip: !isClient
    });
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    useEffect(() => {
        dispatch(setPrevLocation('/marketplace'));
        dispatch(setShowBackButton(true));
    }, [])
    /* ******************** JSX ******************** */

    return(
        <>
            <Grid 
                    paddingLeft={6}
                    paddingTop={7}
            >
                <Typography variant='lora-headline-small'>{title}</Typography>
                <Grid 
                    display={"flex"} 
                    flexDirection={'row'}
                    marginTop={4}
                    gap={4}
                    flexWrap={'wrap'}
                >
                    {
                        globalSlice.userType === 'talent'?  
                        jobs?.filter(j => j.title == title).map((job, idx) => (
                        <Grid item xs="auto" key={idx}>                            
                                <KaziJobCard job={job}/> 
                        </Grid>
                        )):
                        talents?.filter(t => getHasRequiredFields(t) && getSpecialization(t?.resume?.expertise?.primary_expertise) == title).map((talent, idx) => (
                        <Grid item gridTemplateColumns={'repeat(auto-fit, 308px)'} key={idx}>                            
                                <KaziTalentCard talent={talent} sx={{height: '100%'}}/>
                        </Grid>
                        )) 
                    }
                </Grid>
            </Grid>
        </>
    )
}